import React, { useEffect } from "react";
import Paper from '@material-ui/core/Paper';
import { useSelector } from 'react-redux';
import { darktheme, lighttheme } from './theme';
//  RESET TO THIS:
import { StylesProvider, ThemeProvider, MuiThemeProvider } from '@material-ui/core/styles';

import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { initGA } from './Components/analytics';
import { Helmet } from "react-helmet";

// ⚡️ Rubric 3: True Code-Splitting. Moves the heavy dashboard element tree 
// out of the main bundle chunk to prevent initialization blocking.
const MenuDrawer = React.lazy(() => import('./Components/MenuDrawer'));

// Lightweight skeleton matching your page structure
const AppSkeleton = () => (
  <div style={{ width: '100%', padding: '16px', boxSizing: 'border-box' }}>
    <div style={{ width: '100%', height: '220px', backgroundColor: '#e0e0e0', borderRadius: '4px', marginBottom: '16px' }} />
    <div style={{ width: '100%', height: '48px', backgroundColor: '#e0e0e0', borderRadius: '4px', marginBottom: '24px' }} />
    <div style={{ width: '100%', height: '300px', backgroundColor: '#e0e0e0', borderRadius: '4px' }} />
  </div>
);

function App() {
  const isDark = useSelector(state => state.isDark);

  function RootLayout() {
    useEffect(() => {
      // Pre-caches the GA bundle during browser idle time
      if ('requestIdleCallback' in window) {
        requestIdleCallback(() => initGA());
      } else {
        setTimeout(initGA, 2000);
      }
    }, []);

    return <div>...</div>;
  }

  return (
    <StylesProvider injectFirst>
      <MuiThemeProvider theme={isDark ? darktheme : lighttheme}>
        <ThemeProvider theme={isDark ? darktheme : lighttheme}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            
            <Helmet>
              <title>Multi-World Clock & Meeting Scheduler | DateAndTime</title>
              <meta name="description" content="A high-precision multi-timezone dashboard with live Unix timestamps, ordinal dates, and a global meeting planner. Sync your system time instantly." />
              <link rel="canonical" href="https://dateandtime.in/" />
              <meta property="og:type" content="website" />
              <meta property="og:site_name" content="DateAndTime.in" />
              <meta property="og:url" content="https://dateandtime.in/" />
              <meta property="og:title" content="Multi-World Clock & Meeting Scheduler" />
              <meta property="og:description" content="A high-precision multi-timezone dashboard with live Unix timestamps, ordinal dates, and a global meeting planner." />
              <meta property="og:image" content="https://dateandtime.in/og-image.png" />
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:site" content="@dateandtimein" />
              <script type="application/ld+json">
                {JSON.stringify({
                  "@context": "https://schema.org",
                  "@type": "WebApplication",
                  "@id": "https://dateandtime.in/#webapp",
                  "name": "DateAndTime.in",
                  "url": "https://dateandtime.in",
                  "description": "An ultra-lightweight, high-precision custom multi-timezone dashboard.",
                  "offers": { "@type": "Offer", "price": "0.00", "priceCurrency": "INR" }
                })}
              </script>
            </Helmet>

            <Paper square style={{ minHeight: '100vh', width: '100%' }}>
              <div className="App">
                {/* ⚡️ React native streaming layout replaces the redundant state machine */}
                <React.Suspense fallback={<AppSkeleton />}>
                  <MenuDrawer />
                </React.Suspense>    
              </div>
            </Paper>

          </MuiPickersUtilsProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </StylesProvider>
  );
}

export default App;